import type { ChatMessage } from '../types/chat'

export function utteranceLooksLikeNoteTaskStart(text: string): boolean {
  const raw = (text || '').trim()
  if (!raw) return false
  return /\b(create\s+a\s+(?:new\s+)?note|create\s+a\s+task|note\s+that|add\s+a\s+task|take\s+notes?|new\s+note|cr[eé]e\s+une\s+(?:nouvelle\s+)?note|cr[eé]e\s+une\s+t[aâ]che|note\s+que|ajoute(?:r)?\s+une\s+t[aâ]che|prends\s+note|nouvelle\s+note)\b/i.test(
    raw,
  )
}

export function isNoteTaskAwaitingContentClarification(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (m.noteConfirmed || m.noteCancelled) return false
    return m.noteAwaitingContentClarification === true
  }
  return false
}

export function isNoteTaskFlowInProgress(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (m.noteConfirmed || m.noteCancelled) return false
    if (m.awaitingNoteConfirmation || m.noteFlowActive || m.noteAwaitingContentClarification) {
      return true
    }
    return false
  }
  return false
}

/** Note/task preview waiting for yes/no — same strings as reminder/general confirm. */
export function hasPendingNoteConfirmation(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (m.awaitingNoteConfirmation === true && !m.notePreviewResolved) return true
  }
  return false
}

export function shouldUseHostedChatForNoteTask(
  text: string,
  messages: readonly ChatMessage[],
): boolean {
  return utteranceLooksLikeNoteTaskStart(text) || isNoteTaskFlowInProgress(messages)
}

export function wireNotePreviewPayload(raw: Record<string, unknown>) {
  return {
    content: String(raw.content ?? '').trim(),
    language: raw.language != null ? String(raw.language) : undefined,
  }
}
